<section class="login-background">
  <app-pattern></app-pattern>
  <mat-card class="login-card">
    <app-compact-header></app-compact-header>
    <div class="heading-5">{{ 'general.api_login_oauth_title' | translate }}</div>
    <ng-container *ngIf="isLoading">
      <p>{{ 'general.api_login_oauth_description' | translate }}</p>
      <mat-spinner [diameter]="32"></mat-spinner>
    </ng-container>
    <ng-container *ngIf="!isLoading">
      <p class="text-warning">
        <ng-container *ngIf="!state">
          {{ 'general.api_login_oauth_invalid_input' | translate }}
        </ng-container>
        <ng-container *ngIf="state">
          {{ response?.error?.error_description }}
        </ng-container>
      </p>
      <div class="flex flex-column top-spacer-x2">
        <button *ngIf="state" mat-flat-button color="primary" (click)="run()">
          {{ 'general.api_login_oauth_retry' | translate }}
        </button>
        <button mat-stroked-button color="primary" (click)="cancel()">
          {{ 'general.api_login_oauth_cancel' | translate }}
        </button>
      </div>
    </ng-container>
    <div class="align-center version">
      {{ viewService.version }}<ng-container *ngIf="!!viewService.conf.environment"> | {{ viewService.conf.environment }}</ng-container>
    </div>
  </mat-card>
</section>
